<template>
  <div v-if="loading" class="loader-container"><Loader /></div>
  <div v-else>
    <div v-if="blogDetail">
      <BlogDetailBanner
        :v-if="blogDetail"
        :featuredImage="blogDetail.featuredImage"
        :featuredImageAltText="blogDetail.featuredImageAltText"
        :title="blogDetail.title"
        :tags="blogDetail.tags"
        :publishedDate="blogDetail.publishDate"
        :maxReadTime="blogDetail.maxReadTime"
      />
      <div class="blog-body" v-if="blogDetail.body">
        <div class="v-container body-container">
          <BlogDetailBody
            :body="blogDetail.body"
            :title="blogDetail.title"
            :id="blogDetail.id"
            :slug="blogDetail.slug"
            :metaDescription="blogDetail.metaDescription"
            :tags="blogDetail.tags"
          />
        </div>
      </div>

      <Newsletter />
      <BlogDetailRelatedBlogs
        :relatedBlogs="relatedBlogs"
        :currentBlogTags="blogDetail.tags || []"
        :routePath="'/experience-nepal'"
        v-if="relatedBlogs && relatedBlogs.length > 0"
      />
      <GetInTouch background-color="#DEF3FF" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import { useRoute, onBeforeRouteUpdate } from 'vue-router';
import BlogDetailBanner from '../partials/ExperienceDetailBanner.vue';
import BlogDetailBody from '../partials/ExperienceDetailBody.vue';
import Newsletter from '../partials/Newsletter.vue';
import BlogDetailRelatedBlogs from '../partials/DetailRelatedBlogs.vue';
import GetInTouch from './../../service/components/GetInTouch.vue';
import Loader from '@/components/Loader.vue';
import experienceNepalService from '@/services/API/experienceNepalService';

window.scrollTo(0, 0);

const route = useRoute();
const blogId = route.params.id;

const blogDetail = ref(null);
const relatedBlogs = ref([]);

const loading = ref(true);
document.getElementById('loaderSection').classList.add('d-none');

const fetchExperience = async (blogId) => {
  try {
    loading.value = true;
    const response = await experienceNepalService.showExperienceDetail(blogId);
    if (response.status === 200) {
      blogDetail.value = response.data;
      // Check if relatedBlogs is provided by the API
      if (
        blogDetail.value.relatedBlogs &&
        blogDetail.value.relatedBlogs.length > 0
      ) {
        relatedBlogs.value = blogDetail.value.relatedBlogs;
      } 
      
      console.log('Blog Detail:', blogDetail.value);
      console.log('Related Blogs:', relatedBlogs.value);
      console.log('Current Blog Tags:', blogDetail.value?.tags);
    } else {
      throw new Error('Failed to fetch blog details');
    }
  } catch (error) {
    console.error('Error fetching blog:', error);
    relatedBlogs.value = [];
  } finally {
    loading.value = false;
  }
};

onMounted(async () => {
  fetchExperience(blogId);
});

// React to route param changes
onBeforeRouteUpdate((to, from, next) => {
  if (to.path !== from.path) {
    window.scrollTo(0, 0);
    loading.value = true;
    const blogId = to.params.id;
    fetchExperience(blogId);
  }
  next();
});
</script>

<style scoped>
.banner-body {
  background-color: var(--light-1);
}
.body-container {
  max-width: 1280px;
}
.blog-body {
  text-align: left;
  background-color: #f7f8fc;
}
</style>
